class APIS {
	apis() {
		return {
			onboardVoicePortal: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/backend/voice-portal/onboard'
			},
			getUsers: {
				headers: {
					'xt-user-token': null
				},
				method: 'get',
				path: '/backend/voice-portal/users'
			},
			getUserCampaigns: {
				headers: {
					'xt-user-token': null
				},
				method: 'get',
				path: '/backend/voice-portal/campaigns'
			},
			voiceDashboard: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/backend/voice-portal/dashboard'
			},
			vpbxDashboard: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/backend/voice-portal/vpbx-dashboard'
			},
			vpbxWallboard: {
				headers: {
					'xt-user-token': null
				},
				method: 'get',
				path: '/backend/voice-portal/vpbx-wallboard'
			},
			incomingCallReport: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/backend/voice-portal/incoming-call-report'
			},
			outgoingCallReport: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/backend/voice-portal/outgoing-call-report'
			},
			callCenterIncoming: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/backend/voice-portal/call-center-incoming'
			},
			callifyReport: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/backend/voice-portal/callify-report'
			},
			campaignSummary: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/backend/voice-portal/campaign-summary'
			},
			deleteUser: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/backend/voice-portal/user/delete'
			},
		};
	}
}

export default new APIS();
